module.exports = __webpack_public_path__ + "assets/creation-fields-logo.fb5a1397.svg";